(function () {
  'use strict';

  function initCarousel(root) {
    var track = root.querySelector('[data-vc-track]');
    var prevBtn = root.querySelector('[data-vc-prev]');
    var nextBtn = root.querySelector('[data-vc-next]');
    var modal = root.querySelector('[data-vc-modal]');
    var modalMedia = modal ? modal.querySelector('[data-vc-modal-media]') : null;
    var closeEls = modal ? modal.querySelectorAll('[data-vc-close]') : [];
    var openButtons = root.querySelectorAll('[data-vc-open]');
    var lastFocused = null;

    if (!track) return;

    function cardStep() {
      var card = track.querySelector('[data-vc-card]');
      if (!card) return 260;
      var styles = window.getComputedStyle(card);
      var width = card.getBoundingClientRect().width;
      var marginLeft = parseFloat(styles.marginLeft) || 0;
      return width + marginLeft;
    }

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    function scrollByStep(direction) {
      track.scrollBy({ left: direction * cardStep(), behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByStep(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByStep(1);
      });
    }

    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();

    // Keyboard support when the track itself is focused
    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        scrollByStep(1);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        scrollByStep(-1);
      }
    });

    function stopModalMedia() {
      if (!modalMedia) return;
      var video = modalMedia.querySelector('video');
      var iframe = modalMedia.querySelector('iframe');
      if (video) {
        video.pause();
        video.removeAttribute('src');
        video.load();
      }
      if (iframe) {
        iframe.src = 'about:blank';
      }
      modalMedia.innerHTML = '';
    }

    function closeModal() {
      if (!modal) return;
      stopModalMedia();
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    function openModal(card) {
      if (!modal || !modalMedia) return;
      var template = card.querySelector('[data-vc-video-template]');
      if (!template) return;

      lastFocused = document.activeElement;
      stopModalMedia();

      var fragment = template.content
        ? template.content.cloneNode(true)
        : document.createRange().createContextualFragment(template.innerHTML);

      modalMedia.appendChild(fragment);
      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';

      var video = modalMedia.querySelector('video');
      if (video) {
        video.play().catch(function () {
          /* Autoplay may be blocked; controls remain available. */
        });
      }

      var closeBtn = modal.querySelector('[data-vc-close]');
      if (closeBtn) closeBtn.focus();
    }

    openButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('[data-vc-card]');
        if (card) openModal(card);
      });
    });

    closeEls.forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal && !modal.hasAttribute('hidden')) {
        closeModal();
      }
    });
  }


  document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.video-carousel-section');

  sections.forEach(section => {
    const track = section.querySelector('[data-vc-track]');
    const prevBtn = section.querySelector('[data-vc-prev]');
    const nextBtn = section.querySelector('[data-vc-next]');
    const modal = section.querySelector('[data-vc-modal]');
    const modalMedia = section.querySelector('[data-vc-modal-media]');
    const closeBtns = section.querySelectorAll('[data-vc-close]');
    const openBtns = section.querySelectorAll('[data-vc-open]');

    // 1. Carousel Arrow Logic
    if (track && prevBtn && nextBtn) {
      const scrollAmount = window.innerWidth > 768 ? 300 : 200;
      
      prevBtn.addEventListener('click', () => {
        track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });
      
      nextBtn.addEventListener('click', () => {
        track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
    }

    // 2. Open Modal and Autoplay Video Logic
    openBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const card = btn.closest('[data-vc-card]');
        const template = card.querySelector('[data-vc-video-template]');
        
        if (template && modal && modalMedia) {
          // Extract the video/iframe from the hidden template
          const clone = template.content.cloneNode(true);
          modalMedia.innerHTML = '';
          modalMedia.appendChild(clone);
          
          // Show the modal popup
          modal.removeAttribute('hidden');

          // Force the video to play
          const videoElement = modalMedia.querySelector('video');
          if (videoElement) {
            // For native Shopify videos
            videoElement.play().catch(error => {
              console.log('Autoplay was blocked by the browser.', error);
            });
          }
        }
      });
    });

    // 3. Close Modal and Stop Video Logic
    closeBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        if (modal && modalMedia) {
          modal.setAttribute('hidden', '');
          // Emptying the HTML stops the video and audio completely
          modalMedia.innerHTML = ''; 
        }
      });
    });
  });
});

  function initAll() {
    document.querySelectorAll('[data-vc-root]').forEach(function (root) {
      if (root.dataset.vcInitialized) return;
      root.dataset.vcInitialized = 'true';
      initCarousel(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when a merchant adds/edits the section in the theme editor
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-vc-root]');
    if (root) {
      root.dataset.vcInitialized = '';
      initCarousel(root);
    }
  });
})();